/**
 * Front-end behavior for Feature Cards (scoped to block instances).
 */
export class FeatureCardsFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="feature-cards"]' ).forEach( ( el ) => {
			el.classList.add( 'feature-cards-enhanced' );
		} );
	}
}
